import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplicantRequest, Relationship } from '../../../services/http/applicants/applicants.interface';
import { ApplicantsService } from '../../../services/http/applicants/applicants.service';
import { FormsModule } from '@angular/forms';
import { Country } from '../../../services/http/countries/countries.interface';
import { MunicipalityProvinceData } from '../../../services/http/municipalities/municipalities.interface';
import { Province } from '../../../services/http/provinces/provinces.interface';
import { CountriesService } from '../../../services/http/countries/countries.service';
import { ProvincesService } from '../../../services/http/provinces/provinces.service';
import { MunicipalitiesService } from '../../../services/http/municipalities/municipalities.service';
import { AlertService } from '../../../services/alert/alert.service';
import { AlertType } from '../../../services/alert/alert.interface';
import { LoaderService } from '../../../services/loader/loader.service';
import { DialogService } from '../../../services/dialog/dialog.service';
import { ImageSectionHeadComponent } from '../../../components/image-section-head/image-section-head.component';
import { ExceptionsService } from '../../../services/http/exceptions/exceptions.service';
import { CodeName } from '../../../services/http/common.http.interface';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule, FormsModule, ImageSectionHeadComponent, RouterLink],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {
  title = $localize`:@@Router.Profile:Mi perfil`;
  description = "";
  image = "assets/images/teclado.jpg";

  originalApplicant: ApplicantRequest | undefined;
  applicant: ApplicantRequest | undefined;
  password = '';
  countries: Country[] = [];
  provinces: Province[] = [];
  municipalities: MunicipalityProvinceData[] = [];
  relationships: Relationship[] = [];
  isValid = false;
  streetTypes: CodeName[] = [];

  constructor(
    private readonly applicantsService: ApplicantsService,
    private readonly countriesService: CountriesService,
    private readonly provincesService: ProvincesService,
    private readonly municipalitiesService: MunicipalitiesService,
    private readonly alertService: AlertService,
    private readonly loaderService: LoaderService,
    private readonly dialogService: DialogService,
    private readonly exceptionsService: ExceptionsService
  ) { }

  ngOnInit(): void {
    this.countriesService.getCountries().subscribe(
      data => {
        this.countries = data.countries;
      }
    );
    this.provincesService.getProvinces().subscribe(
      data => {
        this.provinces = data.provinces;
      }
    );
    this.applicantsService.getCurrentApplicant().subscribe((applicant: ApplicantRequest) => {
      this.originalApplicant = applicant;
      this.applicant = applicant;
      this.loadMunicipalities();
    });
    this.applicantsService.getRelationships().subscribe(
      data => {
        this.relationships = data.relationships;
        console.log(this.relationships);
      }
    );
    this.exceptionsService.getSteetTypes().subscribe(
      data => {
        this.streetTypes = data.streets;
      }
    );
  }

  loadMunicipalities() {
    let province = '';
    switch (this.applicant?.applicantType) {
      case 'Individual':
        province = this.applicant.individual!.applicantContact.province;
        break;
      case 'Company':
        province = this.applicant.company!.representativeContact.province;
        break;
      case 'Represented':
        province = this.applicant.represented!.representativeContact.province;
        break;
    }
    if (province === '') {
      return;
    }
    this.municipalitiesService.getMunicipalitiesByProvince(province).subscribe(
      data => {
        this.municipalities = data.municipalities;
      }
    );
  }

  changeFlag(flag: string) {
    // Piden quitar esto: 17/02/2025
    // switch (flag) {
    //   case 'email':
    //     this.applicant!.flags!.sms = this.applicant!.flags!.email ? false : this.applicant!.flags!.sms;
    //     break;
    //   case 'sms':
    //     this.applicant!.flags!.email = this.applicant!.flags!.sms ? false : this.applicant!.flags!.email;
    //     break;
    //   default:
    //     break;
    // }
  }

  save(code: string | undefined) {
    // Piden cambiar esto: 17/02/2025, antes solo podia tener uno a true
    if (!this.applicant!.flags!.email && !this.applicant!.flags!.sms) {
      this.alertService.setAlert({
        message: $localize`:@@Profile.NoCommunication:Debe seleccionar al menos un medio de comunicación.`,
        type: AlertType.Error,
        dismissible: true,
        dismissOnTimeout: 2000
      });
      return;
    }
    if (this.applicant!.flags!.sms) {
      let hasPhone = false;
      switch (this.applicant?.applicantType) {
        case 'Individual':
          hasPhone = this.applicant.individual?.applicantContact.phoneNumber !== '';
          break;
        case 'Company':
          hasPhone = this.applicant.company?.representativeContact.phoneNumber !== '';
          break;
        case 'Represented':
          hasPhone = this.applicant.represented?.representativeContact.phoneNumber !== '';
          break;
      }
      if (!hasPhone) {
        this.alertService.setAlert({
          message: $localize`:@@Profile.NoPhoneNumber:Debe introducir un número de teléfono para seleccionar SMS como medio de comunicación.`,
          type: AlertType.Error,
          dismissible: true,
          dismissOnTimeout: 2000
        });
        return;
      }
    }
    // check email
    let email = '';
    switch (this.applicant?.applicantType) {
      case 'Individual':
        email = this.applicant.individual?.applicantContact.email!;
        break;
      case 'Company':
        email = this.applicant.company?.applicantContact.email!;
        break;
      case 'Represented':
        email = this.applicant.represented?.applicantContact.email!;
        break;
    }
    // check format email
    if (!email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)) {
      this.alertService.setAlert({
        message: $localize`:@@Profile.InvalidEmail:El email introducido no es válido.`,
        type: AlertType.Error,
        dismissible: true,
        dismissOnTimeout: 2000
      });
      return;
    }
    if (this.originalApplicant) {
      let username = '';
      let email = '';
      if (this.originalApplicant.individual) {
        this.originalApplicant.individual.applicantContact = this.applicant?.individual?.applicantContact!;
        username = this.applicant?.individual?.applicantIdentification.documentIdentification!;
        email = this.applicant?.individual?.applicantContact.email!;
      }
      if (this.originalApplicant.company) {
        this.originalApplicant.company.applicantContact = this.applicant?.company?.applicantContact!;
        this.originalApplicant.company.representativeContact = this.applicant?.company?.representativeContact!;
        username = this.applicant?.company?.applicantIdentification.documentIdentification!;
        email = this.applicant?.company?.applicantContact.email!;
      }
      if (this.originalApplicant.represented) {
        this.originalApplicant.represented.applicantContact = this.applicant?.represented?.applicantContact!;
        this.originalApplicant.represented.representativeContact = this.applicant?.represented?.representativeContact!;
        username = this.applicant?.represented?.applicantIdentification.documentIdentification!;
        email = this.applicant?.represented?.applicantContact.email!;
      }
      if (this.password) {
        if (code) {
          this.applicantsService.requestCodeRegister({ identifier: username, email: email, password: this.password, confirmationCode: code }).subscribe({
            next: () => {
              this.alertService.setAlert({
                message: $localize`:@@Profile.CodeConfirmed:Se ha cambiado correctamente la contraseña.`,
                type: AlertType.Info,
                dismissible: true,
                dismissOnTimeout: 2000
              });
              this.applicantsService.updateApplicant(this.originalApplicant!).subscribe(
                data => {
                  this.alertService.setAlert({
                    message: $localize`:@@Profile.Updated:Perfil actualizado correctamente.`,
                    type: AlertType.Success,
                    dismissible: true,
                    dismissOnTimeout: 2000
                  });
                  this.loaderService.hide();
                }
              );
            }
          });
        } else {
          this.loaderService.show();
          this.applicantsService.requestCodeRegister({ identifier: username, email: email, password: this.password }).subscribe({
            next: () => {
              this.loaderService.hide();
              this.alertService.setAlert({
                message: $localize`:@@Profile.CodeSent:Se ha enviado un código de verificación a su correo electrónico.`,
                type: AlertType.Info,
                dismissible: true,
                dismissOnTimeout: 2000
              });
              this.dialogService.setDialog({
                title: $localize`:@@Register.Dialog.Title:Código de verificación`,
                message: $localize`:@@Register.Dialog.Message:Se ha enviado un código de verificación a su email. Introduzca el código a continuación.`,
                input: true,
                button1Text: $localize`:@@Register.Dialog.Cancel:Cancelar`,
                button2Text: $localize`:@@Register.Dialog.Accept:Aceptar`,
                button1Callback: () => {
                  this.dialogService.clearDialog();
                },
                button2Callback: (code: string) => {
                  this.save(code);
                  this.dialogService.clearDialog();
                }
              });
            }
          });
        }
      } else {
        this.applicantsService.updateApplicant(this.originalApplicant).subscribe(
          data => {
            this.alertService.setAlert({
              message: $localize`:@@Profile.Updated:Perfil actualizado correctamente.`,
              type: AlertType.Success,
              dismissible: true,
              dismissOnTimeout: 2000
            });
          }
        );
      }
    }
  }
}
